export default "__VITE_ASSET__BzPCMtxB__"